import './Gif.css';
import { RxDoubleArrowDown } from "react-icons/rx";
import { useTranslation } from 'react-i18next';

const Gif = () => {
    const {t} = useTranslation();
    return(
    <div className='homeHeroMS'>
        <div className='heroMS'>
            <div className='textoHeroMS'>
                <span className='refugioMS'>{t('Gif.textoRefugio')}</span>
                <span className='renacerMS'>{t('Gif.textoRenacer')}</span>
            </div>
            <div className='llamadoAccionMS'>
                <span className='reservaTurnoMS'>{t('Gif.reserva')}</span>
                <a href='#servicios' className='reservaBotoonMS'><RxDoubleArrowDown color='#ffffff' size='3.4vw' /></a>
            </div>
        </div>
        <img src='./img/gifHome/gif.webp' alt=''/>
        
    </div>
    )
};

export default Gif;